import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Link } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutMe from './pages/AboutMe';
import AdvisoryBoard from './pages/AdvisoryBoard';
import Research2026 from './pages/Research2026';
import OutputsToolkit from './pages/OutputsToolkit';
import SupportSPI from './pages/SupportSPI';
import CollaboratorSpace from './pages/CollaboratorSpace';
import Admin from './pages/Admin';
import FamilyPortal from './pages/FamilyPortal';
import NilU from './pages/NilU';
import NilUSuccess from './pages/NilUSuccess';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isCollaboratorSpace = location.pathname === '/collaborator-space';
  const isAdmin = location.pathname === '/admin';
  const isFamilyPortal = location.pathname === '/family-portal';

  const isHomePage = location.pathname === '/';
  const showChrome = !isCollaboratorSpace && !isAdmin && !isFamilyPortal;

  return (
    <div className="min-h-screen flex flex-col">
      {showChrome && isHomePage && (
        <Link to="/nil-u" className="block group relative z-[60] bg-black hover:bg-gray-900 transition-colors duration-300 border-b border-gray-800">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-3.5">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3 sm:gap-5">
                <span className="flex-shrink-0 bg-spi-600 text-white text-xs font-bold px-3 py-1 rounded-full tracking-wide uppercase">
                  New
                </span>
                <div>
                  <span className="text-white font-semibold text-sm sm:text-base">NIL U is here</span>
                  <span className="hidden sm:inline text-gray-400 mx-2">&mdash;</span>
                  <span className="hidden sm:inline text-gray-300 text-sm">The student-athlete guide to mastering Name, Image & Likeness</span>
                </div>
              </div>
              <div className="flex items-center gap-2 text-spi-400 group-hover:text-spi-300 transition-colors flex-shrink-0">
                <span className="text-sm font-medium hidden sm:inline">Enroll Your Team</span>
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          </div>
        </Link>
      )}
      {showChrome && <Header />}
      <main className={showChrome ? "flex-grow" : ""}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/advisory-board" element={<AdvisoryBoard />} />
          <Route path="/research-2026" element={<Research2026 />} />
          <Route path="/outputs-toolkit" element={<OutputsToolkit />} />
          <Route path="/support-spi" element={<SupportSPI />} />
          <Route path="/collaborator-space" element={<CollaboratorSpace />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/family-portal" element={<FamilyPortal />} />
          <Route path="/nil-u" element={<NilU />} />
          <Route path="/nil-u/success" element={<NilUSuccess />} />
        </Routes>
      </main>
      {showChrome && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
      <Analytics />
    </Router>
  );
}

export default App;
